//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ListNavigation from '../components/sobre/listNavigation';
import VacanciesEmail from '../components/sobre/vacanciesEmail';
import FirstSection from '../components/sobre/firstSection';
import Directions from '../components/sobre/directions';
import RightArrow from '~/assets/svg/right-arrow.svg?inline';
import { fillUrlFromFilter, getFilterFromUrl } from '../utils/filter';
import Vue from 'vue';

const FILTER_DEFAULTS = {
  location: '',
  direction: 0,
};

export default {
  name: 'Vacancies',
  meta: {
    doNotShow: ['br'],
  },
  components: {
    ListNavigation,
    VacanciesEmail,
    Directions,
    RightArrow,
    FirstSection,
  },
  beforeRouteUpdate(to, from, next) {
    this.needUpdate = Math.random();
    next();
  },
  scrollToTop: true,
  data() {
    const filterDefaults = FILTER_DEFAULTS;
    filterDefaults.location =
      this.$app.config.current.vacancies.locations[0].slug;
    return {
      filterDefaults,
      filter: {
        ...filterDefaults,
      },
      needUpdate: false,
      isSectionsLoaded: false,
      withoutScrollingTrigger: false,

      isFirstLoadOnSever: false,
      isFirstLoadOnClient: false,
      isFirstLoad: true,
    };
  },
  async fetch() {
    if (process.server) this.isFirstLoadOnSever = true;
    if (process.client && !this.isFirstLoadOnSever) {
      this.isFirstLoadOnClient = true;
    }

    if (!this.isFirstLoad) this.isSectionsLoaded = false;

    if (
      process.client &&
      !this.isFirstLoad &&
      this.$scrollTo &&
      !this.withoutScrollingTrigger
    ) {
      if (window.innerWidth > 1023) {
        this.$scrollTo('#content', 300, { offset: 0 });
      }
    }

    const filterFromUrl = getFilterFromUrl({
      route: this.$route,
      router: this.$router,
      windowMode: false,
    });

    if (this.$store.state.vacancies.directions.length === 1) {
      // Directions
      let responseDirections;
      try {
        responseDirections = await this.$axios({
          method: 'post',
          url: `${this.$nuxt.$config.CMS_REST_API}/public/vacancyCategories/`,
        });
      } catch (e) {
        console.error(`error`, e);
        // error({ statusCode: 500, message: 'Os trabalhos técnicos estão em andamento' });
      }

      let directions = [];
      if (responseDirections) {
        if (responseDirections.data.error) {
          throw new Error(
            `An error occurred while executing the query (${responseDirections.data.error})`,
          );
        }

        directions = responseDirections.data.data.data;

        this.$store.commit(
          'vacancies/addDirections',
          Object.assign([], directions),
        );
      }
    }

    if (
      !this.$store.state.vacancies.directions.find(
        (direction) => String(direction.id) === String(filterFromUrl.direction),
      )
    ) {
      filterFromUrl.direction = this.filterDefaults.direction;
    }
    if (
      !this.$store.state.vacancies.locations.find(
        (location) => location.slug === filterFromUrl.location,
      )
    ) {
      filterFromUrl.location = this.filterDefaults.location;
    }
    filterFromUrl.direction = Number(filterFromUrl.direction);

    this.filter = {
      ...this.filter,
      ...filterFromUrl,
    };

    // Vacancies
    let response;
    try {
      response = await this.$axios({
        method: 'post',
        url: `${this.$nuxt.$config.CMS_REST_API}/public/vacancies/`,
        data: {
          locations: [this.currentLocation.value],
          ...(this.currentDirection.id !== 0 && {
            categories: [this.currentDirection.id],
          }),
        },
      });
    } catch (e) {
      console.error(e);
      // error({ statusCode: 500, message: 'Os trabalhos técnicos estão em andamento' });
      // throw e;
    }
    let vacancies = [];
    if (response) {
      if (response.data.error) {
        throw new Error(
          `An error occurred while executing the query (${response.data.error})`,
        );
      }

      vacancies = response.data.data.data;

      this.$store.commit(
        'vacancies/setVacancies',
        Object.assign(
          [],
          vacancies.map((vacancy) => {
            const v = { ...vacancy };
            if (!/^http(s)?:\/\//.test(v.url)) {
              v.url = `//${v.url}`;
            }
            return v;
          }),
        ),
      );
    }

    if (!this.isFirstLoad) this.isSectionsLoaded = true;

    this.isFirstLoad = false;
  },
  head() {
    return {
      title: this.$t('meta.vacancies.title'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('meta.vacancies.description'),
        },
        {
          hid: 'og:url',
          name: 'og:url',
          property: 'og:url',
          content: this.$t('meta.vacancies.url'),
        },
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: this.$t('meta.vacancies.title'),
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: this.$t('meta.vacancies.description'),
        },
        {
          hid: 'og:type',
          name: 'og:type',
          property: 'og:type',
          content: 'website',
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: `https://${
            this.$store?.state?.host
          }${require(`~/assets/${this.$app?.config?.common?.currentCountry}/ebac-logo.png`)}`,
        },
      ],
      script: [{ src: 'https://code.jquery.com/jquery-3.5.1.min.js' }],
    };
  },
  computed: {
    currentDirection() {
      const directions = this.$store.state.vacancies.directions;
      const filter = this.filter;
      const currentDirection = filter.direction;
      return (
        directions.find((direction) => direction.id === currentDirection) ||
        directions[0]
      );
    },
    currentLocation() {
      const locations = this.$store.state.vacancies.locations;
      const filter = this.filter;
      const currentLocation = filter.location;
      return (
        locations.find((location) => location.slug === currentLocation) ||
        locations[0]
      );
    },
    locations() {
      const locations = this.$store.state.vacancies.locations;
      return locations.map((location) => {
        const l = { ...location };
        if (location.slug === this.filter.location) l.active = true;
        l.to = `/vacancies?location=${l.slug}&direction=${this.filter.direction}`;
        return l;
      });
    },
  },
  watch: {
    async needUpdate() {
      if (this.needUpdate) await this.$fetch();
    },
    async isSectionsLoaded() {
      if (this.isSectionsLoaded && !this.isFirstLoad) {
        if (!this.withoutScrollingTrigger) {
          if (window.innerWidth > 1023) {
            this.$scrollTo('#content', 0, { offset: 0 });
            await Vue.nextTick();
            this.$scrollTo('#content', 0, { offset: 0 });
          }
        }

        this.withoutScrollingTrigger = false;
      }
    },
  },
  created() {
    this.$store.commit(
      'vacancies/setLocations',
      this.$app.config.current.vacancies.locations,
    );

    if (process.browser) {
      this.$scrollTo('#__layout', 0);
    }
  },
  methods: {
    async applyFilter(withoutScrolling = false) {
      fillUrlFromFilter({
        router: this.$router,
        filter: this.filter,
        replaceMode: false,
        considerUrlParams: ['courses'],
        ignoreFilterParams: ['coursesOffset', 'professionsOffset'],
      });

      this.withoutScrollingTrigger = withoutScrolling;
    },
    async onFiltersContentSubmit(value) {
      this.filter = { ...this.filter, ...value };
      await this.applyFilter();
    },
  },
};
